import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ProjectInstallBidQuestion} from "../../core/models/project-install-bid-question.interface";
import {InstallAskQuestionDialogComponent} from "../install-ask-question-dialog/install-ask-question-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {InstallBidService} from "../../core/services/install-bid.service";

@Component({
  selector: 'app-install-question',
  templateUrl: './install-question.component.html',
  styleUrls: ['./install-question.component.scss']
})
export class InstallQuestionComponent {
  @Input() question: ProjectInstallBidQuestion;
  @Input() installerId: number;
  @Input() installBidId: number;
  @Input() locked: boolean = false;
  @Output('updateQuestionEmitter') updateQuestionEmitter = new EventEmitter<void>();

  busy: boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private installBidService: InstallBidService) {
  }

  askQuestion() {
    let config: any = {
      width: '950px',
      maxWidth: '90vw',
      data: {
        parentQuestionId: this.question.id
      }
    };
    if (!this.busy) {
      const confirm = this.dialog.open(InstallAskQuestionDialogComponent, config);
      confirm.afterClosed().subscribe((result) => {
        if (result) {
          this.busy = true;
          this.installBidService.submitQuestion(this.installerId, this.installBidId, result).subscribe({
            next: (projectInstallQuestions) => {
              //this.question.questions = projectInstallQuestions;
              this.updateQuestionEmitter.emit();
              this.busy = false;
            },
            error: (err) => {
              this._snackBar.open('Submit Question Failed: ' + err.error.message);
              this.busy = false;
            }
          });
        }
      });
    }
  }

  handleUpdateQuestionEmitter() {
    this.updateQuestionEmitter.emit();
  }
}
